import * as React from 'react';
import { FilterPanel } from './filter-panel';
import { FilterItemField } from './filter-item-field';
import { Filter, FilterConfigurationProps } from './types';
import { getFieldId, getInitialValues, countFilter } from './selectors';

import styles from './filter-item.scss';

interface FilterItemProps {
  filter: Filter;
  filterSettings: FilterConfigurationProps;

  translation: any;
  locale: string;
}

export class FilterItem extends React.PureComponent<FilterItemProps> {

  private onClear = () => {

    const { filter, filterSettings: {
      defaultFilterValues, onChange, onChangeMenu
    } } = this.props;

    filter.fields.forEach(field => {

      const id = getFieldId(filter.id, field.fieldTypeId);

      onChange(id, getInitialValues(filter.id, field.fieldTypeId, defaultFilterValues));
      onChangeMenu(id, undefined);
    });
  };

  public render() {
    const { filter, filterSettings, translation, locale } = this.props;

    const { values, openFilters, openCloseFilter } = filterSettings;

    return <FilterPanel
      id={filter.id}
      header={filter.label}
      count={countFilter(filter.fields, values, filter.id)}
      open={openFilters[filter.id]}
      openCloseFilter={openCloseFilter}>
      {!!filter.fields && filter.fields.map(
        field =>
          <div className={styles.filterItem} key={getFieldId(filter.id, field.fieldTypeId)}>
            <FilterItemField
              id={getFieldId(filter.id, field.fieldTypeId)}
              field={field}
              filterSettings={filterSettings}
              translation={translation}
              locale={locale}
              onClear={this.onClear} />
            {!!field.divider && <hr />}
          </div>
      )}
    </FilterPanel>;
  }
}
